import StarThankYou from "./star-thank-you.svg";

export default StarThankYou;
